const moment = require("moment");

const constants = {};

constants.feedbackStatus = {
  1: "Working",
  2: "Problem",
};

constants.currencyFormatter = (input, needSymbol = true) => {
  let options = needSymbol
    ? {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
      }
    : {
        minimumFractionDigits: 0,
      };

  if (input) {
    return input.toLocaleString("en-IN", options);
  } else {
    return (0).toLocaleString("en-IN", options);
  }
};

constants.serviceTypeMap = [
  {
    key: 1,
    value: "Free",
  },
  {
    key: 2,
    value: "Chargeable",
  },
  {
    key: 3,
    value: "Cost Service",
  },
  {
    key: 4,
    value: "Free Replacement",
  },
  {
    key: 5,
    value: "StandBy",
  },
  {
    key: 6,
    value: "Free Service",
  },
];

constants.serviceType = {
  1: "Free",
  2: "Chargeable",
  3: "Cost Service",
  4: "Free Replacement",
  5: "StandBy",
  6: "Free Service",
};

constants.maxQuantity = 1000;

constants.getInvoiceFormat = (invoiceNumber, createdAt) => {
  if (!createdAt) {
    createdAt = moment();
  }
  if (createdAt) {
    const dt = moment(createdAt);
    const lastTwoDigits = dt.year() % 100;
    return `STS/${invoiceNumber}/${lastTwoDigits}${lastTwoDigits + 1}`;
  }
  return invoiceNumber;
};

constants.INVOICE_COUNTER = {
  SPARE: "spare",
  QUOTATION: "quotation",
  INDENT: "indent",
  DELIVER_CHALLAN: "delivery_challan",
  ORDER_REQUEST: "order_request",
};

constants.SERIAL_LABEL = {
  autoleveller_board: "Autoleveller Board",
  b90_unit: "B90 Unit",
  b90_sensor: "B90 Sensor",
  b50_sensor_with_amplifier: "B50 Sensor With Amplifier",
  b91_encoder: "B91 Encoder",
  b93_encoder: "B93 Encoder",
  hmi_unit: "HMI Unit",
  plc_unit: "PLC Unit",
  main_motor: "Main Motor",
  main_motor_inverter: "Main Motor Inverter",
  servo_motor: "Servo Motor",
  servo_amplifier: "Servo Amplifier",
  rk_50_small_resistor: "50 RK Small Resistor",
  kw_1_5_big_resistor: "1.5KW Big Resistor",
  suction_motor: "Suction Motor",
  acc_motor: "Acc Motor",
};

constants.DESIGNATION_ROLE = {
  6: "Admin",
  1: "Design",
  2: "Store General",
  3: "Store Raw",
  4: "Production Manager",
  5: "Worker",
  7: "Service Engineer",
};

constants.DESIGNATION = {
  ADMIN: "Admin",
  DESIGN: "Design",
  STORE_GENERAL: "Store General",
  STORE_RAW: "Store Raw",
  PRODUCTION_MANAGER: "Production Manager",
  WORKER: "Worker",
  SERVICE_ENGINEER: "Service Engineer",
};

constants.DESIGNATION_ROLE_MAP = {
  ADMIN: 6,
  DESIGN: 1,
  STORE_GENERAL: 2,
  STORE_RAW: 3,
  PRODUCTION_MANAGER: 4,
  WORKER: 5,
  SERVICE_ENGINEER: 7,
};

constants.classroomLogTemplate = ["name", "grade", "year", "thumbnail"];
constants.studentLogTemplate = ["name", "username", "email", "mobile"];
constants.userLogTemplate = ["name", "role", "email", "mobile"];

constants.statusText = {
  0: "Pending - PM",
  1: "Rejected - PM",
  2: "Rejected - SI",
  11: "Approved - PM",
  12: "Approved - SI",
  13: "PO-Created",
};

constants.productTypeMapConstant = {
  TOOLS: "1",
  CONSUMABLES: "2",
  RAW_MATERIAL: "3",
};

constants.productType = [
  // {
  // 	value: "1",
  // 	label: "Tools",
  // },
  {
    value: "2",
    label: "Consumables",
  },
  {
    value: "3",
    label: "Raw material",
  },
  {
    value: "4",
    label: "Sub Contract",
  },
];

constants.roleMap = {
  1: "Admin",
  2: "Manager",
  3: "Engineer",
};

constants.role = {
  ADMIN: 1,
  MANAGER: 2,
  ENGINEER: 3,
};

constants.deviceList = [
  {
    key: 1,
    value: "Rig",
  },
  {
    key: 2,
    value: "Rig+Fuel",
  },
  {
    key: 3,
    value: "Lorry",
  },
  {
    key: 4,
    value: "Compressor",
  },
  {
    key: 5,
    value: "Single Compressor",
  },
  {
    key: 6,
    value: "Single Compressor + Rod",
  },
  {
    key: 7,
    value: "Single IMEI",
  },
  {
    key: 8,
    value: "single IMEI - rig",
  },
  {
    key: 10,
    value: "Single IMEI + Rod",
  },
];

// Device dropdowns show the type number with the name ("1. Rig") so it matches
// what the device and the logs report as device_type.
constants.deviceOptionLabel = (item) => `${item.key}. ${item.value}`;

constants.deviceStatusList = [
  {
    key: 1,
    value: "Live",
  },
  {
    key: 2,
    value: "Memory Clear",
  },
  // {
  //     key: 3,
  //     value: "Odo meter reset"
  // },
  {
    key: 7,
    value: "Point Number Reset",
  },
  // {
  //     key: 7,
  //     value: "Point no reset"
  // },
  // {
  //     key: 5,
  //     value: "Geo Fence Reset"
  // },
  {
    key: 8,
    value: "Total Reset",
  },
];

constants.deviceStatusMap = {
  1: "Live",
  2: "Memory Clear",
  7: "Point Number Reset",
  8: "Total Reset",
};

constants.gpsStatusList = [
  {
    key: 1,
    value: "Internal",
  },
  {
    key: 10,
    value: "External",
  },
  {
    key: 5,
    value: "Quactel",
  },
];

constants.gpsStatusMap = {
  1: "Internal",
  10: "External",
  5: "Quactel",
};

constants.debugStatusList = [
  {
    key: 1,
    value: "Live",
  },
  {
    key: 5,
    value: "Low",
  },
  {
    key: 9,
    value: "High",
  },
];

constants.debugStatusMap = {
  1: "Live",
  5: "Low",
  9: "High",
};

constants.noOfFuelTankList = [
  {
    key: 0,
    value: 0,
  },
  {
    key: 1,
    value: 1,
  },
  {
    key: 2,
    value: 2,
  },
  {
    key: 3,
    value: 3,
  },
  {
    key: 4,
    value: 4,
  },
];

// Display names. 9 is no longer offered in the Device dropdown (owner, 2026-11-05:
// no device uses it) but keeps its name here so an old record would still show one.
// 6 was "Single Compressor 1" (never used) and is now "Single Compressor + Rod".
constants.deviceMap = {
  1: "Rig",
  2: "Rig+Fuel",
  3: "Lorry",
  4: "Compressor",
  5: "Single Compressor",
  6: "Single Compressor + Rod",
  7: "Single IMEI",
  8: "single IMEI - rig",
  9: "borewell monitor",
  10: "Single IMEI + Rod",
};

constants.rigTimingList = [
  {
    key: 1,
    value: "Normal",
  },
  {
    key: 2,
    value: "Fast",
  },
];

constants.rigLogicList = [
  {
    key: 1,
    value: "PHE",
  },
  {
    key: 2,
    value: "Switch Logic",
  },
  {
    key: 3,
    value: "Velson",
  },
];

constants.displayConfigList = [
  {
    key: 1,
    value: "FW rod",
  },
  {
    key: 2,
    value: "reverse rod",
  },
  {
    key: 3,
    value: "current drilling time",
  },
  {
    key: 4,
    value: "previous driling time",
  },
  {
    key: 5,
    value: "RPM Compersor",
  },
  {
    key: 6,
    value: "fuel1",
  },
  {
    key: 7,
    value: "fuel2",
  },
  {
    key: 8,
    value: "fuel3",
  },
  {
    key: 9,
    value: "fuel4",
  },
  {
    key: 10,
    value: "fuel5",
  },
  {
    key: 11,
    value: "TotalFuel",
  },
  {
    key: 12,
    value: "instant_milage_display",
  },
  {
    key: 13,
    value: "DisplayOFF",
  },
    {
    key: 14,
    value: "milage_display",
  },
  {
    key: 15,
    value: "Device deactivate",
  },
  {
    key: 16,
    value: "fuel 1+2",
  },
];

constants.bioConfigList = [
  {
    key: 1,
    value: "pnp",
  },
  {
    key: 2,
    value: "npn",
  },
];

constants.sspConfigList = [
  {
    key: 1,
    value: "pnp",
  },
  {
    key: 2,
    value: "npn",
  },
  {
    key: 3,
    value: "deactivate",
  },
];

// 2026-07-10 firmware: MST is a 4-way source + polarity select (3/4 = the BIO
// input wired as the master sensor).
constants.mstConfigList = [
  {
    key: 1,
    value: "MST pin - PNP",
  },
  {
    key: 2,
    value: "MST pin - NPN",
  },
  {
    key: 3,
    value: "BIO pin - PNP",
  },
  {
    key: 4,
    value: "BIO pin - NPN",
  },
];

// 2026-07-13 firmware: CAN engine data ce — 1 appends the 7 J1939 fields to the
// online record (F103RET6 CAN build only; other boards ignore it).
constants.canEngineDataList = [
  {
    key: 0,
    value: "Off",
  },
  {
    key: 1,
    value: "On (J1939)",
  },
];

// 2026-07-10 firmware: sleep mode se — 1 = GSM RF off (fast wake), 2 = modem
// powered off (lowest power, slower wake; heartbeat floored at 10 min).
constants.sleepModeList = [
  {
    key: 0,
    value: "Off",
  },
  {
    key: 1,
    value: "Light sleep (GSM off)",
  },
  {
    key: 2,
    value: "Deep sleep (modem off)",
  },
];

constants.offlineConfigList = [
    {
    key: 0,
    value: "enable",
  },
    {
    key: 1,
    value: "disable",
  },
  {
    key: 100,
    value: "100",
  },
  {
    key: 101,
    value: "101",
  },
    {
    key: 102,
    value: "102",
  },

    {
    key: 103,
    value: "103",
  },

    {
    key: 104,
    value: "104",
  },

    {
    key: 105,
    value: "105",
  },

      {
    key: 99,
    value: "99",
  },

      {
    key: 98,
    value: "98",
  },

      {
    key: 97,
    value: "97",
  },

      {
    key: 96,
    value: "96",
  },





  //   {
  //   key: 0,
  //   value: "enable",
  // },
  // {
  //   key: 1,
  //   value: "disable",
  // },



];

constants.rpmRcbConfigList = [
  {
    key: 0,
    value: "without rcp input",
  },
  {
    key: 1,
    value: "with rcp input",
  },
  {
    key: 2,
    value: "with rcp input constant 1500 rpm",
  },
  {
    key: 3,
    value: "rcp as rpm input",
  },
];

constants.rpmjumperSetting = [
  {
    key: 0,
    value: "20 milli volt",
  },
  {
    key: 1,
    value: "1.2 volt",
  },
];

constants.buzzerOutputList = [
  {
    key: 1,
    value: "enable",
  },
  {
    key: 2,
    value: "disable",
  },
  {
    key: 3,
    value: "mode1",
  },
  {
    key: 4,
    value: "mode2",
  },
  {
    key: 5,
    value: "mode3",
  },
];

constants.mstGeoFenceResetList = [
  {
    key: 1,
    value: "enable",
  },
  {
    key: 2,
    value: "disable",
  },
  {
    key: 3,
    value: "mode1",
  },
  {
    key: 4,
    value: "mode2",
  },
  {
    key: 5,
    value: "mode3",
  },
];

constants.offlineStoreDrainList = [
  {
    key: 1,
    value: "enable",
  },
  {
    key: 2,
    value: "disable",
  },
  {
    key: 3,
    value: "mode1",
  },
  {
    key: 4,
    value: "mode2",
  },
  {
    key: 5,
    value: "mode3",
  },
];

constants.fuelTankTypeList = [
  {
    key: 1,
    value: "Lorry",
  },
  {
    key: 2,
    value: "Upper 1",
  },
  {
    key: 3,
    value: "Lower 1",
  },
  {
    key: 4,
    value: "Upper 2",
  },
  {
    key: 5,
    value: "Lower 2",
  },
];

constants.sensorTypeList = [
  {
    key: 1,
    value: "Wired",
  },
  {
    key: 2,
    value: "Bluetooth",
  },
];

constants.topDash = {
  border: "1px dashed blue",
  borderBottom: "0",
  borderLeft: "0",
  minWidth: "25px",
  height: "25px",
  position: "relative",
  top: "1.5rem",
};

constants.downDash = {
  border: "1px dashed blue",
  borderTop: "0",
  borderLeft: "0",
  minWidth: "25px",
  height: "25px",
  position: "relative",
  top: "-1rem",
  left: "-1.55rem",
};

constants.downLast = {
  border: "1px dashed blue",
  borderTop: "0",
  borderLeft: "0",
  minWidth: "25px",
  height: "25px",
  position: "relative",
  top: "-1rem",
};

constants.lineFirst = {
  minWidth: "30px",
  border: "1px dashed blue",
  height: "0px",
  position: "relative",
  top: "2.7rem",
  borderBottom: "0px",
};

constants.line = {
  minWidth: "30px",
  border: "1px dashed blue",
  height: "0px",
  position: "relative",
  top: "2.7rem",
  left: "-1.5rem",
  borderBottom: "0px",
};

constants.sleepLogicList = [
  {
    key: 1,
    value: "Type 1",
  },
  {
    key: 2,
    value: "Type 2",
  },
  {
    key: 3,
    value: "Type 3",
  },
  {
    key: 4,
    value: "Type 4",
  },
  {
    key: 5,
    value: "Type 5",
  },
];

constants.protocolList = [
  {
    key: 1,
    value: "HTTP",
  },
  {
    key: 2,
    value: "MQTT",
  },
];

constants.otaList = [
  {
    key: 1,
    value: "Enable",
  },
  {
    key: 2,
    value: "Disable",
  },
];

constants.tempSensorTypeList = [
  {
    key: 1,
    value: "pt 100",
  },
  {
    key: 2,
    value: "j type",
  },
  {
    key: 3,
    value: "k type",
  },
];

// advs[44] `tas` — which calibrated temperature the over-temperature buzzer
// (`ta` threshold, adv17) compares. Firmware SW101, small_chip_ver 19+.
// A device that never receives the key defaults to 0 (water).
constants.tempAlertSourceList = [
  {
    key: 0,
    value: "Water temperature",
  },
  {
    key: 1,
    value: "Oil temperature",
  },
  {
    key: 2,
    value: "Either (whichever exceeds)",
  },
];

module.exports = constants;
